module.exports = __webpack_public_path__ + "media/application/images/svgs/dollar-sign-b6c2934dc2615c89f251f79f91063a39.svg";